// 9fbef606107a605d69c0edbcd8029e5d
import React, { useMemo } from 'react';
import ImageTag from '../styles/Image.style';

const ImageRenderer = ({ categoryData, isQuickView }) => {
  return useMemo(() => {
    if (!categoryData) return <></>;

    const { imagePathWeb = '', showImageWeb = false } = categoryData;
    if (showImageWeb && imagePathWeb) {
      return (
        <ImageTag
          className="department-size-chart-image-section"
          src={imagePathWeb}
          alt="department-size-chart-image"
          isQuickView={isQuickView}
        />
      );
    }
    return <></>;
  }, [categoryData]);
};

export default ImageRenderer;
